export const formatDate = (dateString: string): string => {
  const formattedDate = new Date(Date.parse(dateString))?.toLocaleDateString('en-US', {
    weekday: 'long',
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit'
  })

  return formattedDate.replace(/,([^,]*)$/, ' at$1')
}

export const getUserFullName = (userAttributes: any): string => {
  return `${userAttributes.given_name as string} ${userAttributes.family_name as string}`
}

export const formatPercent = (value: number | unknown): string => {
  if (typeof value !== 'number') return 'N/A'
  return `${Math.round(value * 100)}%`
}

export const formatNumber = (value?: number | unknown): any => {
  if (typeof value !== 'number') return null
  return value % 1 === 0 ? value.toString() : value.toFixed(2).replace(/\.?0+$/, '')
}

export const capitalizeFirst = (str: string): string => {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1)
}
